<template>
  <div>
    <please-wait-modal/>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Edit Setting Point</h1>
    </div>
    <div class="">
      <div class="form-group col-12">
        <div class="row px-3">
          <label for="#form-user-type" class="col-lg-4 pl-0 m-0 d-flex align-items-center">User Type</label>
          <select class="form-control" v-model="user_type" id="form-user-type">
            <option value="All">All</option>
            <option value="Helper">Helper</option>
            <option value="Majikan">Majikan</option>
          </select>
        </div>
      </div>
      <div class="form-group col-12">
        <div class="row px-3">
          <label for="#form-subject" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Subject</label>
          <input type="text" class="form-control" id="form-subject" placeholder="Subject" v-model="subject">
        </div>
      </div>
      <div class="form-group col-12">
        <div class="row px-3">
          <label for="#form-content" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Content</label>
          <textarea class="form-control" id="form-content" rows="15" v-model="content"></textarea>
        </div>
      </div>
      <div class="form-group col-12 text-right">
        <a type="button" class="btn btn-danger" href="/setting/email">Cancel</a>
        <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#preloader_modal" @click="save">Send</button>
      </div>
    </div>
  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'
import 'summernote/dist/summernote.css'
import summernote from 'summernote'

export default {
  components:{
    'please-wait-modal': please_wait_modal,
  },
  data(){
    return{
      subject: '',
      content: '',
      user_type: 'All',
    }
  },
  async mounted(){
    var context = this
    $('#form-content').summernote({
			height: '250',
			width: '100%',
			callbacks: {
				onChange: function(contents, $editable) {
					context.content = contents
				}
			},
			popover: {
				image: [],
				link: [],
				air: []
			},
			toolbar: [
				['style', ['bold', 'italic', 'underline', 'clear']],
				['font', ['strikethrough', 'superscript', 'subscript']],
				['fontsize', ['fontsize']],
				['color', ['color']],
				['para', ['ul', 'ol', 'paragraph']],
			]
		})
    await this.get_data()
  },
  methods:{
    async get_data(){
      try{
        var response = await axios.get(base_url+'/setting-email?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.subject = response_data.data.subject
          this.content = response_data.data.content
          this.user_type = response_data.data.user_type
          $('#form-content').summernote('code', this.content)
        }
      } catch(e) {
        this.$toasted.show(e.message)
      }
    },
    async save(){
      try{
        if(this.subject == '')
          this.$toasted.show('Subject is empty')
        else if(this.content == '')
          this.$toasted.show('Content is empty')
        else{
          $('#please_wait_modal').modal('show')
          var data = {}
          data.id = this.$route.query.id
          data.subject = this.subject
          data.content = this.content
          data.user_type = this.user_type

          var response = await axios.put(base_url+'/setting-email',data)

          $('#please_wait_modal').modal('hide')
          var response_data = response.data
          if(response_data.status == "success"){
            location.href = '/setting/email'
          }
          else
            this.$toasted.show(response_data.message)
        }
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    }
  }
}
</script>
